var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8759 4.83391C19.1057 4.48932 19.5713 4.39615 19.916 4.6259C20.2606 4.85565 20.3537 5.3213 20.124 5.66594L11.124 19.1659C10.9994 19.3528 10.7976 19.4738 10.5742 19.496C10.3506 19.5182 10.1286 19.4391 9.96967 19.2802L3.96967 13.2802C3.67678 12.9873 3.67678 12.5125 3.96967 12.2196C4.24427 11.9451 4.67901 11.9276 4.97357 12.1679L5.03021 12.2196L10.3828 17.5722L18.8759 4.83391Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.f0c6f18a9c92cb1332dbc5b4927350b5.svg";
export { ForwardRef as ReactComponent };